<template>
  <div>
    <a-modal
      title="授权账号"
      width="450px"
      :visible="visible"
      :maskClosable="false"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form :form="form" class="form">
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
          <a-input addon-before="账号" placeholder="请输入账号" :disabled="this.data !== null" v-decorator="['account', { rules: [{required: true, message: '请输入账号，账号为手机号码!'}]}]"/>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol" v-if="isAccount">
          <a-input addon-before="昵称" placeholder="请输入昵称" v-decorator="['nickname', { rules: [{required: true, message: '请输入昵称!'}]}]"/>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol" v-if="isAccount">
          <a-input addon-before="密码" placeholder="请输入密码" v-decorator="['pwd', { rules: [{required: true, message: '请输入密码!'}]}]"/>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol" v-if="agencyInfo.verifyStatus === 1">
          <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">项目</span>
          <a-select style="width:350px;" placeholder="请选择注册项目" mode="multiple" v-decorator="['programIds']">
            <a-select-option :value="item.programId + ''" v-for="(item, index) in agencyProgram" :key="index">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
          <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">权限</span>
          <a-select style="width:350px;" placeholder="请选择权限" mode="multiple" v-decorator="['permKeys',{ rules: [{ required: true, message: '请选择权限' }] },]">
            <a-select-option :value="item.url" v-for="item in matchFun.centerMenuList(false)" :key="item.url">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
          <a-input addon-before="备注" placeholder="请输入备注" v-decorator="['remarks', { rules: [{message: '请输入备注!'}]}]"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import matchFun from '@comm/utils/matchFun'
import { mapState } from 'vuex'
export default {
  components: {
  },
  data () {
    return {
      visible: false,
      confirmLoading: false,
      matchFun: matchFun,
      isAccount: false,
      data: null,
      agencyId: null,
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState({
      accountId: state => state.user.accountId,
      agencyInfo: state => state.agency.agencyInfo,
      agencyProgram: state => state.agency.agencyProgram
    })
  },
  methods: {
    show (data, agencyId) {
      this.isAccount = false
      this.agencyId = agencyId
      this.data = data
      if (this.data !== null) {
        this.formData()
      } else {
        setTimeout(() => {
          this.form.setFieldsValue({
            account: '',
            programIds: [],
            permKeys: [],
            remarks: ''
          })
        })
      }
      this.visible = true
    },
    formData () {
      setTimeout(() => {
        this.form.setFieldsValue({
          account: this.data.account,
          programIds: this.data.programIds.split(','),
          permKeys: this.data.permKeys.split(','),
          remarks: this.data.remarks
        })
      })
    },
    handleOk (e) {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          if (!matchFun.phoneFun(values.account)) {
            this.$message.error('手机号码不正确')
            return
          }
          values.agencyId = this.agencyId
          if (this.data !== null) {
            values.accountId = this.data.accountId
            values.id = this.data.id
            this.submitAccount(values)
          } else {
            if (!this.isAccount) {
            // 验证手机号码是否已注册
              this.$api.high.verifyRegister({account: values.account}).then(res => {
                if (res && res.status === 0 && res.data === 0) { // 账号未注册
                  this.isAccount = true
                } else {
                  if (res.data === this.accountId) {
                    this.$message.error('禁止给自己授权')
                  } else {
                    values.accountId = res.data
                    this.submitAccount(values)
                  }
                }
              }).catch(err => {
                console.log(err)
              })
            } else {
              this.$api.high.accountRegister(values).then(res => {
                if (res.status === 0) {
                  if (res.data === this.accountId) {
                    this.$message.error('禁止给自己授权')
                  } else {
                    values.accountId = res.data
                    this.submitAccount(values)
                  }
                }
              }).catch(err => {
                console.log(err)
              })
            }
          }
        }
      })
    },
    submitAccount (values) {
      this.$api.high.addOrUpSubaccount(values).then(res => {
        if (res.status === 0) {
          this.handleCancel()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleCancel (e) {
      this.visible = false
      this.$emit('ok')
    }
  }
}
</script>
<style scoped>
.form /deep/ .ant-select-selection{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/center/AuthForm.vue